import { ProductionArea } from "../enums/production-area.enum";

export const titles = {
  [ProductionArea.Grinding]: "Grinding",
  [ProductionArea.HPR]: "ConSys",
  [ProductionArea.Hoisting]: "Hoisting",
} satisfies Record<ProductionArea, string>;
